var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('UserListPickerModal',{attrs:{"fromAgentPicker":true,"emitOnAction":true,"queryOverride":_vm.queryOverride},on:{"tableRowClicked":function($event){return _vm.$emit('tableRowClicked', $event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }